import React from 'react'

import { Box, Divider, Typography } from '@mui/material'

import ResponsiveDisplayWrapper from '../../../../shared/components/ResponsiveDisplayWrapper/ResponsiveDisplayWrapper.component'

import env from '../../../../networkRequests/apiClient/env.config'
import date, { dateTimeFormats } from '../../../../shared/functions/Date/date.functions'
import useResponsiveness from '../../../../shared/hooks/responsive.hooks'
import styles from './MiniTripDetails.styles'
import { MiniTripDetailsProps } from './MiniTripDetails.types'

const MiniTripDetails: React.FC<MiniTripDetailsProps> = ({ flightItinerary }) => {
  const [isDesktop] = useResponsiveness()

  // Parse environment variable with default value of 1
  const dateOffset = parseInt(env.SHARED_TRIP_TRAVEL_DATE_OFFSET || '1', 10) || 1

  return (
    <Box sx={styles.container}>
      <Typography variant="h6" sx={styles.title}>
        Trip Details
      </Typography>

      <Box sx={styles.tripDetails}>
        {flightItinerary.itinerary.legs.map((leg, index) => (
          <Box key={index} sx={styles.legContainer}>
            <Box sx={styles.legDetails}>
              <Typography variant="h6" sx={styles.route}>
                {isDesktop
                  ? `${leg.origin.city.name} → ${leg.destination.city.name}`
                  : `${leg.origin.city.iataCode} → ${leg.destination.city.iataCode}`}
              </Typography>

              <Typography variant="body2" sx={styles.arrivalLabel}>
                Arrives by&nbsp;
                <Typography variant="body2" sx={styles.arrivalDate}>
                  {date(date(leg.travelDate).add({ days: dateOffset })).format(dateTimeFormats.date.medium)}
                </Typography>
              </Typography>

              <ResponsiveDisplayWrapper isDesktop={false} style={styles.separatorWrapper}>
                {index < flightItinerary.itinerary.legs.length - 1 && <Divider sx={styles.separator} />}
              </ResponsiveDisplayWrapper>
            </Box>

            <ResponsiveDisplayWrapper isDesktop={true}>
              {index < flightItinerary.itinerary.legs.length - 1 && <Divider sx={styles.separator} />}
            </ResponsiveDisplayWrapper>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default MiniTripDetails
